export interface ExpansionZone {
  slug: string;
  title: string;
  shortLabel: string;
  status: 'Under Review' | 'Published';
  summary: string;
  travelerFit: string;
  evidence: string;
  stayCandidates: string[];
}

export const EXPANSION_ZONES: ExpansionZone[] = [
  {
    slug: 'willamette-valley-truffle-corridor',
    title: 'Willamette Valley Truffle Corridor',
    shortLabel: 'Classic valley route',
    status: 'Published',
    summary:
      'The core wine-country weekend built around Newberg, McMinnville, Dayton, forest access, dining anchors, and the strongest stay base in the guide.',
    travelerFit:
      'Best suited to travelers who want the fullest Oregon truffle weekend rather than a single city-base outing or event stop.',
    evidence:
      'Current source notes support guided winter tours, McMinnville festival marketplace activity, Newberg resort dining, Dayton mushroom-focused dining, and through-May private-adventure framing.',
    stayCandidates: ['Atticus Hotel', 'The Allison Inn & Spa'],
  },
  {
    slug: 'portland-foothills-estacada',
    title: 'Portland Foothills / Estacada',
    shortLabel: 'Portland-access zone',
    status: 'Published',
    summary:
      'A Portland-oriented day-trip angle built around seasonal forest forays, PSU market stops, and urban-access truffle experiences.',
    travelerFit:
      'Best suited to travelers staying in Portland who want guided access without building a full Willamette Valley overnight trip.',
    evidence:
      'Current Truffle Connection pages support Portland departures, Estacada-area forest language, and recurring PSU market appearances in winter 2026.',
    stayCandidates: ['Sentinel Hotel', 'The Nines, Portland'],
  },
  {
    slug: 'corvallis-truffle-science',
    title: 'Corvallis / Truffle Science',
    shortLabel: 'Academic zone',
    status: 'Published',
    summary:
      'An education-first micro-zone centered on NATS meetings, annual society events, and truffle science rather than polished tourism framing.',
    travelerFit:
      'Best suited to readers interested in training, field knowledge, societies, and the technical side of Oregon truffles.',
    evidence:
      'NATS currently documents public meetings in Corvallis and a 2026 annual potluck event, which is enough to support a narrow academic leg even though most forays remain member-restricted.',
    stayCandidates: ['Hilton Garden Inn Corvallis', 'Courtyard by Marriott Corvallis'],
  },
  {
    slug: 'eugene-festival-dog-training',
    title: 'Eugene / Festival and Dog Training',
    shortLabel: 'Southern valley zone',
    status: 'Published',
    summary:
      'A Eugene-centered event and training angle built around Oregon Truffle Festival programming, the Joriad, and seasonal dog-training travel.',
    travelerFit:
      'Best suited to festival travelers and readers planning around ticketed events, training weekends, and Eugene hotel stays.',
    evidence:
      'Current Oregon Truffle Festival pages still support Eugene event relevance, but the marketplace itself is no longer the Eugene anchor.',
    stayCandidates: ['Inn at the 5th Eugene', 'The Gordon Hotel', 'Graduate by Hilton Eugene'],
  },
];
